import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"2\" class=\"nc-icon-wrapper\" transform=\"scale(.5)\"><path stroke-linecap=\"square\" d=\"M3 1h26v30H3z\"></path><path d=\"M22 18.5V9h-9v11.5\" data-cap=\"butt\" data-color=\"color-2\"></path><circle cx=\"10.5\" cy=\"20.5\" r=\"2.5\" stroke-linecap=\"square\" data-color=\"color-2\"></circle><circle cx=\"19.5\" cy=\"18.5\" r=\"2.5\" stroke-linecap=\"square\" data-color=\"color-2\"></circle></g>", 1)
  ]))]))
}
export default { render: render }